import { PropsWithChildren, ReactNode, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ProfessionalDetail } from '@/components/Consultation/steps/Match/ProfessionalDetail'
import { ReviewingRequestAnimation } from '@/components/icons/ReviewingRequestAnimation'
import { WritingReportAnimation } from '@/components/icons/WritingReportAnimation'
import { useConsultation } from '@/hooks/useConsultation'
import { getProfessionalKey, getSlugTranslation } from '@/locale/utils'

interface ProfessionalCardProps {
  footer?: ReactNode
  reviewing?: boolean
}

export const ProfessionalCard = ({ footer, reviewing = false, children }: PropsWithChildren<ProfessionalCardProps>) => {
  const { t } = useTranslation()
  const { consultation } = useConsultation()

  const [showPhysicianDetail, setShowPhysicianDetail] = useState(false)

  const professional = consultation?.professional

  if (!professional) return null

  return (
    <>
      <div className="flex w-full flex-col items-center gap-3 rounded-2xl bg-white p-4 pt-8 shadow-sm">
        {professional.profileImg && <img src={professional.profileImg} className="h-24 w-24 rounded-full" />}

        <h2 className="text-2xl font-bold">
          {t(getProfessionalKey(professional), {
            name: professional.name
          })}
        </h2>

        {professional.profileUrl && (
          <button
            className="w-full pb-3"
            onClick={() => {
              setShowPhysicianDetail(true)
            }}
            data-testid="view-profile-button"
          >
            <p className="text-primary text-sm font-bold">{getSlugTranslation('view_profile')}</p>
          </button>
        )}

        {children}

        <span className="flex items-center justify-center py-3">{reviewing ? <ReviewingRequestAnimation /> : <WritingReportAnimation />}</span>

        {footer}
      </div>

      {showPhysicianDetail && <ProfessionalDetail professional={professional} onClose={() => setShowPhysicianDetail(false)} />}
    </>
  )
}
